import { TokenStorage } from "@/services/tokenStorage";

export const UnauthorizedGuard = () => {
  if (TokenStorage.getToken() != null) {
    return { name: "dashboard" };
  }
  return true;
};
